import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import WhatWeBuild from "@/components/home/WhatWeBuild";
import FeaturedCapability from "@/components/home/FeaturedCapability";
import WhyUs from "@/components/home/WhyUs";
import ProcessTimeline from "@/components/home/ProcessTimeline";
import TechSection from "@/components/home/TechSection";
import IndustriesSection from "@/components/home/IndustriesSection";
import FutureServices from "@/components/home/FutureServices";
import CtaSection from "@/components/home/CtaSection";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useSite } from "@/lib/content";

const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "LogiTech Nexus",
  email: "info@logitechnexus.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "6731 N 17th St",
    addressLocality: "Tacoma",
    addressRegion: "WA",
    postalCode: "98406-1901",
    addressCountry: "US",
  },
  description:
    "LogiTech Nexus designs and develops custom software, web applications, SaaS platforms and workflow automation for businesses.",
};

export default function Home() {
  const { data } = useSite();
  const seo = data?.settings?.seo?.["/"];

  return (
    <>
      <Seo
        title={seo?.title || "LogiTech Nexus | Custom Software Development Company in Tacoma, WA"}
        siteName="LogiTech Nexus"
        description={
          seo?.description ||
          "LogiTech Nexus designs and builds custom software, web applications, SaaS platforms and workflow automation for businesses. Based in Tacoma, WA — serving clients everywhere."
        }
        image="/og-image.png"
        jsonLd={ORG_JSONLD}
      />
      <Hero />
      <Marquee />

      <section className="border-b border-slate-800/60 bg-navy/40 py-24 sm:py-32" data-testid="positioning-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Eyebrow>From Idea to Intelligent Software</Eyebrow>
            <div className="mt-6 grid gap-10 lg:grid-cols-2">
              <h2 className="font-display text-2xl font-semibold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
                We turn ideas, workflows and operational challenges into reliable digital solutions.
              </h2>
              <p className="self-end text-base leading-relaxed text-slate-400">
                Every business runs on processes — some written down, most living in
                inboxes, spreadsheets and people's heads. LogiTech Nexus works with
                you to understand how your business really operates, then designs and
                builds the software that makes it run smarter.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <WhatWeBuild />
      <FeaturedCapability />
      <WhyUs />
      <ProcessTimeline />
      <TechSection />
      <IndustriesSection />
      <FutureServices />
      <CtaSection />
    </>
  );
}
